import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import LoadingDots from 'components/loadingDots'
import { component } from './hoc'
import styles from './app.styles'
import Unauthorized from './screens/unauthorized'

const App = ({
  classes, messages, locale, ready, authorized, store,
}) =>
  (
    <Provider store={store}>
      <ConfigProvider locale={locale}>
        <div className={classes.app}>
          {authorized && <div className={classes.content}>
            <span className={classes.connecting}>{messages.connecting}</span> <LoadingDots />
          </div>}
          {ready && !authorized && <Unauthorized />}
        </div>
      </ConfigProvider>
    </Provider> 
  )

App.propTypes = {
  classes: PropTypes.shape({
    app: PropTypes.string,
  }),
  messages: PropTypes.object,
  locale: PropTypes.object,
  ready: PropTypes.bool,
  authorized: PropTypes.bool,
  permissions: PropTypes.array,
}

App.defaultProps = {
  classes: {},
  messages: {},
  locale: {},
  ready: false,
  authorized: false,
  permissions: [],
}

export default component({ styles })(App)
